import "./OrderActions.css";
import { MdVisibility } from "react-icons/md";

function OrderActions({
  order,
  updateStatus,
  onView,
}) {
  return (
    <div className="order-actions">

      {/* Pending */}
      {order.status === "Pending" && (
        <>
          <button
            className="accept-btn"
            onClick={() =>
              updateStatus(order._id, "Accepted")
            }
          >
            Accept
          </button>

          <button
            className="reject-btn"
            onClick={() =>
              updateStatus(order._id, "Rejected")
            }
          >
            Reject
          </button>
        </>
      )}

      {/* Accepted */}
      {order.status === "Accepted" && (
        <button
          className="prepare-btn"
          onClick={() =>
            updateStatus(order._id, "Preparing")
          }
        >
          Preparing
        </button>
      )}

      {/* Preparing */}
      {order.status === "Preparing" && (
        <button
          className="dispatch-btn"
          onClick={() =>
            updateStatus(order._id, "Ready For Pickup")
          }
        >
          Ready For Pickup
        </button>
      )}

      {/* Waiting for Delivery Partner */}
      {order.status === "Ready For Pickup" && (
        <button
          className="waiting-btn"
          disabled
        >
          Waiting for Delivery Partner
        </button>
      )}

      {/* Delivery Partner Accepted */}
      {order.status === "Out For Delivery" && (
        <button
          className="delivery-progress-btn"
          disabled
        >
          Out For Delivery
        </button>
      )}

      {/* Delivered */}
      {order.status === "Delivered" && (
        <button
          className="completed-btn"
          disabled
        >
          Delivered
        </button>
      )}

      {/* Rejected */}
      {order.status === "Rejected" && (
        <button
          className="rejected-btn"
          disabled
        >
          Rejected
        </button>
      )}

      {/* View */}
      <button
        className="view-btn"
        onClick={() => onView(order)}
      >
        <MdVisibility />
      </button>

    </div>
  );
}

export default OrderActions;